import zakelijk from '../../data/klachtenreglement.json';
import consument from '../../data/klachtenreglement-consument.json';

/**
 * Twee versies van het klachtenreglement (besluit 16): B2B voor opdrachtgevers,
 * professionals en opleiders, en een consumentenversie voor medewerkers die zelf
 * betalen in de Academy (geen fatale termijn, niet-bindende uitspraak, weg naar de rechter open).
 */
export type ReglementVariant = 'zakelijk' | 'consument';
export type Klachtenreglement = typeof zakelijk;

export const KLACHTENREGLEMENTEN: Record<ReglementVariant, Klachtenreglement> = { zakelijk, consument };

/** Medewerkers zijn consument; alle andere rollen (ook beheer) krijgen standaard de B2B-versie. */
export const reglementVariantVoorRol = (role?: string | null): ReglementVariant => (role === 'medewerker' ? 'consument' : 'zakelijk');
